"use client";

import { useUser } from "@/components/clients/LocaleToStorage";
import { useScopedI18n } from "@/messages/client";
import { useMemo } from "react";
import toast from "react-hot-toast";
import useSWR from "swr";
import { DirectusFile } from "../ProductDisplay";

export default function Datasheet({
  datasheet,
  name,
}: {
  datasheet: (DirectusFile | null)[];
  name: string;
}) {
  const t = useScopedI18n("选型器");

  const { user } = useUser();

  const currentFile = useMemo(() => {
    const level = user?.role?.level;
    if (level) {
      return datasheet[level - 1];
    }

    return datasheet.filter(Boolean)?.[0];
  }, [user, datasheet]);

  // const { data } = useSWR<{
  //   data: {
  //     id: string;
  //     filename_download: string;
  //     title: string;
  //     type: string;
  //     uploaded_on: string;
  //   };
  // }>(
  //   () =>
  //     currentFile
  //       ? `${process.env.NEXT_PUBLIC_API_HOST}/files/${currentFile}`
  //       : null,
  //   async (url: string) => {
  //     return fetch(url).then((res) => res.json());
  //   }
  // );

  // if (!data?.data) {
  //   return null;
  // }

  if (!user) {
    return (
      <div
        className="flex items-center text-xs"
        onClick={() => {
          toast.error(t("请先登录"));
        }}>
        <span className="text-[#555555]">{t("数据表")}：</span>

        <span className="cursor-pointer text-[#007c8c] transition-all duration-300 hover:underline">
          PDF
        </span>
      </div>
    );
  }

  return (
    <a
      target="_blank"
      title={currentFile?.title}
      href={`${process.env.NEXT_PUBLIC_DIRECTUS_ASSETS}/${currentFile?.id}/${currentFile?.filename_download}`}
      className="flex items-center text-xs">
      <span className="text-[#555555]">{t("数据表")}：</span>

      <span className="cursor-pointer text-[#007c8c] transition-all duration-300 hover:underline">
        PDF
      </span>
    </a>
  );
}
